import { Platform } from 'react-native';
import * as Sentry from 'sentry-expo';

export const SentryPlatform = Platform.OS === 'web' ? Sentry.Browser : Sentry.Native;